<template>
  <a-lazy-hydrate when-visible>
    <a-banner
      class="sidebar__banner"
      :wrapped-in-card="true"
      :banner-settings="$options.consts.BANNER_SETTINGS.SIDEBAR.RIGHT_SIDE_2"
    />
  </a-lazy-hydrate>
</template>

<script>
import ABanner from 'shared/ABanner'
import { BANNER_SETTINGS } from 'enums/banners/banner-settings'

export default {
  name: 'SidebarBannerMiddle',
  components: {
    ABanner
  },
  consts: {
    BANNER_SETTINGS
  }
}
</script>

<style lang="scss" scoped>
.sidebar__banner {
  margin: 40px 0;
}
</style>
